export const TECH_SUPPORT_MODE_STORAGE_KEY = 'byhelp.techSupportMode';

const CUSTOM_EVENT_NAME = 'byhelp:techSupportModeChanged';

export const readTechSupportMode = (): boolean => {
  try {
    return localStorage.getItem(TECH_SUPPORT_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writeTechSupportMode = (enabled: boolean): void => {
  try {
    localStorage.setItem(TECH_SUPPORT_MODE_STORAGE_KEY, String(enabled));
  } catch {
    // ignore
  }

  window.dispatchEvent(
    new CustomEvent<boolean>(CUSTOM_EVENT_NAME, { detail: enabled })
  );
};

export const toggleTechSupportMode = (): boolean => {
  const next = !readTechSupportMode();
  writeTechSupportMode(next);
  return next;
};

export const subscribeTechSupportMode = (
  listener: (enabled: boolean) => void
) => {
  const onStorage = (e: StorageEvent) => {
    if (e.key !== TECH_SUPPORT_MODE_STORAGE_KEY) return;
    listener(readTechSupportMode());
  };

  const onCustom = (e: Event) => {
    const custom = e as CustomEvent<boolean>;
    listener(Boolean(custom.detail));
  };

  window.addEventListener('storage', onStorage);
  window.addEventListener(CUSTOM_EVENT_NAME, onCustom);

  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener(CUSTOM_EVENT_NAME, onCustom);
  };
};
